var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWagerIcon = function SvgWagerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m6.372 8.14-1.943.67c.733-2.15 3.009-5.216 7.572-5.216 5.28 0 7.31 4.112 7.819 6.215a.5.5 0 0 0 .971-.235c-.555-2.294-2.827-6.98-8.79-6.98-4.974 0-7.545 3.265-8.453 5.715l-.946-1.563a.594.594 0 1 0-1.016.615l1.597 2.638c.145.239.437.345.701.254l2.875-.99a.594.594 0 1 0-.387-1.122m15.842 9.314a.594.594 0 0 1-.815-.2l-.947-1.564c-.907 2.451-3.478 5.716-8.452 5.716-5.963 0-8.235-4.686-8.79-6.98a.5.5 0 1 1 .971-.235c.51 2.103 2.539 6.215 7.82 6.215 4.562 0 6.837-3.066 7.57-5.216l-1.943.67a.594.594 0 0 1-.386-1.124l2.875-.99a.594.594 0 0 1 .7.255l1.598 2.638c.17.28.08.646-.2.815",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    d: "m9 9 6 6M15 9l-6 6"
  })));
};
export default SvgWagerIcon;